<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds medium"
  data-testId="confirmation-dialog"
>
  <div
    class="flx-modal-title font-normal"
    flxModalHeaderTitle
  >
    @if (data.action === 'update') {
      Change <span class="font-bold">{{ data.attribute?.name }}</span> type
    } @else {
      Are you sure you want to delete
      @if (data.attribute) {
        <span class="font-bold">{{ data.attribute.name }}</span> attribute in
      }
      <span class="font-bold">{{ data.dataType?.name }}</span>
      type?
    }
  </div>

  @if (data.action === 'update') {
    <div
      class="flx-modal-subtitle"
      flxModalHeaderSubtitle
    >
      @if (hasTypeSpecificValidators() && data.resourceUsages.length > 0) {
        Changing the attribute type will remove any type specific validators and break the following
        attribute references:
      } @else if (hasTypeSpecificValidators()) {
        By changing attribute type any type-specific validators will be removed and must be
        reconfigured.
      } @else if (data.resourceUsages.length > 0) {
        Changing the attribute type will break the following attribute references:
      }
    </div>
  } @else if (data.resourceUsages.length > 0) {
    <div
      class="flx-modal-subtitle"
      flxModalHeaderSubtitle
    >
      This {{ ApplicationResourceType.ProjectDataType }} is used in several resources. Deleting it
      may break references and impact configurations.
    </div>
  }

  <div class="flx-modal-body">
    <flx-resource-usages-delete-confirmation
      [resourceUsages]="data.resourceUsages"
      (viewUsagesClicked)="openResourceUsagesModal(data.dataType, 'fromDeleteConfirm', $event)"
    />
  </div>

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        data-testId="confirmation-modal-cancel-button"
        flxButton
        type="button"
      >
        Cancel
      </button>
      <button
        (click)="confirm()"
        class="flx-ds primary danger"
        data-testId="confirmation-modal-confirm-button"
        flxButton
        type="button"
      >
        {{ data.action === 'update' ? 'Change Type' : 'Delete' }}
      </button>
    </div>
  </div>
</flx-modal>
